import { Button, Pagination, PaginationItemType } from '@heroui/react';
import { OnChangeFn, PaginationState } from '@tanstack/react-table';
import ArrowCircleRightIcon from '@/shared/assets/icons/arrow-circle-right.svg';
import ArrowCircleLeftIcon from '@/shared/assets/icons/arrow-circle-left.svg';
import { Svg } from '@/shared/ui/Svg';
import styles from './TableFooter.module.scss';

interface TableFooterProps {
  total: number;
  pagination: PaginationState;
  setPagination: OnChangeFn<PaginationState>;
}

export const TableFooter = ({ total, pagination, setPagination }: TableFooterProps) => (
  <div className={styles.root}>
    <Pagination
      size="sm"
      variant="light"
      total={total}
      page={pagination.pageIndex + 1}
      onChange={(page) => setPagination({ ...pagination, pageIndex: page - 1 })}
      classNames={{
        wrapper: styles.wrapperPagination,
        cursor: styles.paginationCursor,
        item: styles.paginationItem,
        prev: styles.paginationControl,
        next: styles.paginationControl,
      }}
      className="pt-3 pb-4"
      showControls
      isCompact
      renderItem={({ value, activePage, total: totalPages, isActive, onNext, onPrevious, setPage, children, key }) => {
        if (value === PaginationItemType.PREV) {
          if (activePage === 1) return null;
          return (
            <Button
              key={key}
              onPress={onPrevious}
              className="min-w-6 min-h-6 flex items-center justify-center p-0 bg-transparent border-none outline-none mr-1.5 cursor-pointer"
            >
              <Svg Icon={ArrowCircleLeftIcon} className="w-5 h-5 text-grey-secondary" />
            </Button>
          );
        }
        if (value === PaginationItemType.NEXT) {
          if (activePage === totalPages) return null;
          return (
            <Button
              key={key}
              onPress={onNext}
              className="min-w-6 min-h-6 flex items-center justify-center p-0 bg-transparent border-none outline-none ml-1.5 cursor-pointer"
            >
              <Svg Icon={ArrowCircleRightIcon} className="w-5 h-5 text-grey-secondary" />
            </Button>
          );
        }
        return (
          <Button
            key={key}
            onPress={() => typeof value === 'number' && setPage(value)}
            className={`min-w-auto min-h-auto px-1.5 text-base bg-transparent ${isActive ? 'font-bold cursor-default' : 'cursor-pointer hover:opacity-70'}`}
          >
            {children}
          </Button>
        );
      }}
    />
  </div>
);
